/**
* Returns an array of elements with a tabindex. By default,
* it searches within the document, but you can provide a root element.
*
* @param {HTMLElement|Document} [root=document] - The container to search in.
* @returns {HTMLElement[]} - An array of focusable elements having a tabindex,
*                            excluding those with tabindex="-1".
*/
export const getFocusableItems = (root = document) => {
  return Array.from(
    root.querySelectorAll("[tabindex]:not([tabindex='-1'])")
  );
}

/**
* Returns the next focusable element (with tabindex) after the current element.
*
* @param {HTMLElement} current - The current element.
* @param {HTMLElement|Document} [root=document] - The container to search in.
* @param {boolean} [wrap=true] - Whether to wrap to the first element if at end.
* @returns {HTMLElement|null} - The next element or null if not found.
*/
export const getNextFocusable = (current, root = document, wrap = true) => {
  const items = getFocusableItems(root);
  const currentIndex = items.indexOf(current);
  if (currentIndex === -1) return null;

  const next = items[currentIndex + 1];
  if (next) return next;

  return wrap ? items[0] : null;
}
/**
* Sets an element's tabindex based on a media query.
* When the viewport matches the query (min-width: 992px), tabindex is set to -1.
* Otherwise, tabindex is set to 0.
*
* @param {HTMLElement} element - The DOM element to update.
*/
export const setResponsiveTabIndex = (element, type='min') => {

  const mq = window.matchMedia(`(${type}-width: 992px)`);
  const updateTabIndex = (e) => {
    if (e.matches) {
      element.setAttribute('tabindex', '-1');
    } else {
      element.setAttribute('tabindex', '0');
    }
  }
  mq.addEventListener('change', updateTabIndex);
  updateTabIndex(mq);
}